import React from 'react';
import { styled } from '@glitz/react';
import { translate } from '@avensia/scope';
import Products, { Layout } from 'Product/ProductCard/List';
import EsalesProductForList from '../../../Esales/Models/EsalesProductForList.type';
import { delta, omega, pixelsToUnit, minMediumMediaQuery } from 'Shared/Style';

type PropType = {
  recentlyViewed: EsalesProductForList[];
};

const Base = styled.section({
  padding: {
    x: pixelsToUnit(15),
  },
});

const ResponsiveH2 = styled.h2({
  fontSize: delta,
  textAlign: 'center',
  textTransform: 'uppercase',
  letterSpacing: pixelsToUnit(3.2),
  margin: {
    bottom: pixelsToUnit(28),
  },
  [minMediumMediaQuery]: {
    fontSize: omega,
  },
});

export default (props: PropType) => (
  <Base>
    <ResponsiveH2>{translate('/Product/RecentlyViewed')}</ResponsiveH2>
    <Products products={props.recentlyViewed} layout={Layout.Block} />
  </Base>
);
